export default "__VITE_ASSET__1ce2b8e5__"